'use strict';

// status codes from deletion events sent by the Jet server
module.exports = {
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE'
};